import * as Yup from 'yup';

export const validationSchema = Yup.object({
  reasonForCancellation: Yup.string()
    .required('You must provide a reason for cancellation')
    .min(3, 'You must provide a reason for cancellation'),
  intentionToCancel: Yup.bool().oneOf([true], 'You must agree to cancel'),
});
